// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Organism_Menu from "../../design-system/organism/menu/Organism_Menu.bs.js";
import * as Organism_Menu_Ds from "../../design-system/organism/menu/Organism_Menu_Ds.bs.js";

function Corporate_Menu(Props) {
  var buttonMore = Props.buttonMore;
  var currentLinkId = Props.currentLinkId;
  var links = Props.links;
  var navLabel = Props.navLabel;
  var search = Props.search;
  var tmp = {
    buttonMore: buttonMore,
    links: links,
    navLabel: navLabel,
    style: Organism_Menu_Ds.corporate
  };
  if (currentLinkId !== undefined) {
    tmp.currentLinkId = Caml_option.valFromOption(currentLinkId);
  }
  if (search !== undefined) {
    tmp.search = Caml_option.valFromOption(search);
  }
  return React.createElement(Organism_Menu.make, tmp);
}

var make = Corporate_Menu;

export {
  make ,
}
/* react Not a pure module */
